import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import classnames from 'classnames';

const Counter = ({resultsTitle, remain, total, sidebar, loading}) => {
  const wrapperClasses = classnames({
    'd-none': !sidebar,
    'd-md-inline-block ': true
  });
  return (
    <span className={wrapperClasses}>
      <span>
        {!sidebar && (`${resultsTitle}: `)}<b>{remain}/{!loading && total}</b>{sidebar && (` ${resultsTitle}`)}
      </span>
      {loading && <span className="ml-1 loading-spinner text-small align-text-bottom"/>}
    </span>
  );
};

Counter.propTypes = {
  resultsTitle: PropTypes.string.isRequired,
  remain: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  sidebar: PropTypes.bool,
  loading: PropTypes.bool
};

export default observer(Counter);
